module.exports = __webpack_public_path__ + "static/media/sponcer_SWC.be4ddc10.jpg";